import {
  createDirectus,
  rest,
  authentication,
  readItems,
  createItem,
  updateItem,
  deleteItem,
  readItem,
  aggregate,
  updateItems,
  uploadFiles,
  readFiles,
  deleteFiles,
  readAssetRaw,
} from "@directus/sdk";

const client = createDirectus(location.origin)
  .with(authentication("cookie"))
  .with(rest());

async function get(filter, groupBy, aggregate, fields, sort, limit, deep) {
  let obj = {
    fields: [
      "*, thread_id.*,to_emails.*,attachments.*,attachments.directus_files_id.*",
    ],
  };
  if (fields) obj.fields = fields;
  if (groupBy) obj.groupBy = groupBy;
  if (filter) obj.filter = filter;
  if (aggregate) obj.aggregate = aggregate;
  if (sort) obj.sort = sort;
  if (limit) obj.limit = limit;
  if (deep) obj.deep = deep;
  const data = await client.request(readItems("messages", obj));
  return data;
}
async function getByUser() {
  const data = await client.request(
    readItems("messages", {
      filter: {
        /* user_created: {
          _eq: id,
        }, */
      },
      fields: ["*"],
    })
  );
  return data;
}

async function getUnreadCount(email, mailbox_id) {
  return await client.request(
    aggregate("messages", {
      aggregate: { count: "*" },
      query: {
        filter: {
          _and: [
            {
              mailbox_id: {
                _eq: mailbox_id,
              },
            },
            {
              thread_id: {
                date_archived: {
                  _null: "true",
                },
              },
            },
            {
              date_read: {
                _null: "true",
              },
            },
            {
              is_inbox: {
                _eq: "true",
              },
            },
            {
              date_archive: {
                _null: "true",
              },
            },
          ],
        },
      },
    })
  );
}
async function getByEmailThread(id, filter, selectedFields, limit, sort) {
  const obj = {
    sort: [sort ? sort : "date_created"],
    filter: {
      ...filter,
      thread_id: {
        id: { _eq: id },
      },
    },
    fields: selectedFields
      ? selectedFields
      : ["*,attachments.*,attachments.directus_files_id.*"],
  };
  if (limit) obj.limit = limit;
  const data = await client.request(readItems("messages", obj));
  return data;
}
async function getById(id) {
  return await client.request(
    readItem("messages", id, {
      fields: ["*"],
    })
  );
}
async function create(data) {
  return await client.request(
    createItem("messages", data, {
      fields: ["*,to_emails.*"],
    })
  );
}
async function addFiles(files) {
  const formData = new FormData();
  files.forEach((file, index) => {
    formData.append(`files[${index}]`, file);
  });
  return await client.request(uploadFiles(formData));
}

async function getFileById(id) {
  return await client.request(readAssetRaw(id));
}
async function deletedFiles(ids) {
  return await client.request(deleteFiles(ids));
}
async function getFiles(ids) {
  return await client.request(
    readFiles({
      filter: {
        id: {
          _in: ids,
        },
      },
      fields: ["*"],
    })
  );
}

async function updateById(id, data) {
  return await client.request(
    updateItem("messages", id, data, {
      fields: ["*,to_emails.*"],
    })
  );
}

async function updateItemsById(ids, data) {
  return await client.request(
    updateItems("messages", ids, data, {
      fields: ["*,to_emails.*"],
    })
  );
}
async function deleteById(id) {
  return await client.request(deleteItem("messages", id));
}
export default {
  get,
  create,
  deleteById,
  getById,
  updateById,
  getByUser,
  getByEmailThread,
  getUnreadCount,
  updateItemsById,
  addFiles,
  getFiles,
  deletedFiles,
  getFileById,
};
